import React from 'react';
import Element from '../../../../components/element';
import Flex from '../../../../components/flex';
import Text from '../../../../components/text';
import ReactHtmlParser from 'html-react-parser';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import { get } from 'lodash';

class TimeEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hours: '',
      minutes: '',
      time: '',
      meridiem: 'AM'
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { rawAnswers, storeAnswer, index, checkSurveyState } = this.props;
    if (rawAnswers) {
      this.setState(rawAnswers, () => {
        checkSurveyState(this);
      });
    } else {
      // storeAnswer(index, this.state);
    }
  }

  handleChange = type => e => {
    const { storeAnswer, questionId, onlyMinutes, onlyHours } = this.props;
    let value = e.target.value;
    if (type === 'minutes' || onlyMinutes) {
      if (value.length > 1) {
        let firstNum = Number(value[0]);
        let secondNum = value[1];
        if (firstNum > 6) {
          value = '0' + firstNum;
        } else if (firstNum == 6) {
          value = '60';
        } else {
          value = firstNum;
          if (secondNum) {
            value += secondNum;
          }
        }
      }
    } else if (type === 'hours' || onlyHours) {
      if (value.length > 1) {
        let firstNum = Number(value[0]);
        let secondNum = value[1];
        if (firstNum > 1 ||(firstNum >=1 && secondNum > 2)) {
          value = '12';
        } else {
          value = `${firstNum}${secondNum}`;
        }
      }
    } else {
      if (value.endsWith(':')) {
        let firstNum = Number(value[0]);
        let secondNum = Number(value[1]);
        if (firstNum == 0 && secondNum == 0) {
          value = '01';
        } else if (firstNum > 1 || (firstNum >=1 && secondNum > 2)) {
          value = '12';
        } else {
            value = `${firstNum}${secondNum}`;
        }
        
      } else 
        if (value.length > 3) {
          let firstNum = Number(value[0]) || 0;
          let secondNum = Number(value[1]) || 0;
          let thirdNum = Number(value[3]) || 0;
          let fourthNum = Number(value[4]) || 0;
          if (
            firstNum == 0 &&
            secondNum == 0 &&
            thirdNum == 0 &&
            fourthNum == 0
          ) {
            value = '01:00';
          } else if (firstNum > 1 || (firstNum >=1 && secondNum > 2)) {
            value = `12:${thirdNum}${fourthNum}`;
            if (thirdNum >= 6) {
              value = `${value.split(':')[0]}:59`;
            }
          } else if (thirdNum >= 6) {
            value = `${value.split(':')[0]}:59`;
          } 
        }
    }
    this.setState({ [type]: value }, () => {
      storeAnswer(questionId, this.state, this.isQuestionAnswered());
      // checkSurveyState(this);
    });
  };

  onBlur = type => e => {
    const { value } = e.target;
    // const { validation, isAnswerValid } = this.props;
    // if (isAnswerValid && get(validation, 'event') === 'blur') {
    //   if (!isAnswerValid(value)) {
    //     this.handleChange(type)({ target: { value: '00:00' } });
    //   }
    //   if (get(validation, 'type') === 'difference') {
    //   }
    // }
    // if (value) {
    if (type === 'time') {
      if (value.endsWith(':')) {
        this.handleChange(type)({ target: { value: value + '00' } });
      } else if (value.length === 1) {
        this.handleChange(type)({ target: { value: `0${value}:00` } });
      } else if (value.length === 4) {
        this.handleChange(type)({ target: { value: value + '0' } });
      } else if (!value) {
        this.handleChange(type)({ target: { value: '00:00' } });
      }
    } else {
      !value && this.handleChange(type)({ target: { value: '00' } });
    }
    // }
  };

  onMeridiemSelect = e => {
    const { storeAnswer, questionId } = this.props;
    this.setState({ meridiem: e.value }, () => {
      if (this.state.time) {
        storeAnswer(questionId, this.state, this.isQuestionAnswered());
        // checkSurveyState(this);
      }
    });
  };

  isQuestionAnswered = () => {
    return !!(this.state.hours || this.state.minutes || this.state.time);
  };

  render() {
    const { text, question, className, picker } = this.props;

    return (
      <div className={`${className}`}>
        <Element type="p" fontFamily="GTAM" fontSize="14px">
          {ReactHtmlParser(question)}
        </Element>
        <Flex align="end">
          {picker && (
            <Flex align="center" width="18%">
              <InputMask
                mask="99:99"
                maskChar={null}
                placeholder="00:00"
                onChange={this.handleChange('time')}
                onBlur={this.onBlur('time')}
                value={this.state.time}
                className={`survey-text survey-item-${text.size}`}
              />
            </Flex>
          )}
          {!picker && text.hours && (
            <Flex align="center" width="22%">
              <input
                type="number"
                onChange={this.handleChange('hours')}
                onBlur={this.onBlur('hours')}
                value={this.state.hours}
                className={`survey-text survey-item-${text.size}`}
              />
              <div className={`survey-label`}>{text.hours}</div>
            </Flex>
          )}
          {picker && (
            <Element marginLeft="16px" width="100%">
              <Select
                options={[
                  { value: 'AM', label: 'AM' },
                  { value: 'PM', label: 'PM' }
                ]}
                placeholder=""
                className={`survey-dropdown survey-item-${text.size}`}
                onChange={this.onMeridiemSelect}
                value={this.state.meridiem}
                searchable={false}
                clearable={false}
              />
            </Element>
          )}
          {!picker && !!text.hours && !!text.minutes && (
            <Text size="12px" family="GTAM" margin="0 28px">
              or
            </Text>
          )}
          {!picker && !!text.minutes && (
            <Flex align="center" width="22%">
              <input
                type="number"
                onChange={this.handleChange('minutes')}
                onBlur={this.onBlur('minutes')}
                value={this.state.minutes}
                className={`survey-text survey-item-${text.size}`}
              />
              <div className={`survey-label`}>{text.minutes}</div>
            </Flex>
          )}
        </Flex>
      </div>
    );
  }
}

export default TimeEditor;
